import POIImagePreview from "@/components/POI/POIImagePreview/POIImagePreview.vue";
import _ from "lodash";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getImageDimensionSizes } from "../../../helpers/commonHelper";
import { uploadFile } from "../../../helpers/fileHelper";

export default {
  name: "POIConferenceRoomsEditDialog",
  components: {
    POIImagePreview,
    InfoDialog
  },
  props: ["editedRoom", "editedItem", "dialog"],
  data: () => ({
    step: 1,
    mainDragging: false
  }),
  methods: {
    async addDropFile(e, type) {
      if (!this.editedItem?._id && !this.editedItem?.id) {
        await this.$store.dispatch("createError", {
          text: "Bitte zuerst speichern!"
        });
        return; // without specific id already set, we are creating a mess when multiple files are uploaded - we would create a poi for each file here
      }

      if (!Array.isArray(this[`${type}Files`])) this[`${type}Files`] = [];
      const files = e?.dataTransfer?.files ?? e ?? [];

      await Array.from(files).asyncForEach(async file => {
        const isPdfFile = file.type.toLowerCase() === "application/pdf";

        const data = await uploadFile(
          file,
          this.editedItem.id || this.editedItem._id,
          "pois",
          this.editedItem.principal,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );

        if (type === "main" && !data.imageSizes && data.url) {
          data.imageSizes = await getImageDimensionSizes(data.url);
        } else if (type === "file" && isPdfFile) {
          const generatedPdfPicture = await this.generateImageFromPdf(
            data.url,
            data.title.replace(".pdf", "")
          );
          data.picture = await uploadFile(
            generatedPdfPicture,
            this.editedItem.id || this.editedItem._id,
            "pois",
            this.editedItem.principal,
            progressEvent => {
              this.$store.dispatch(
                "createSuccess",
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % Bild aus PDF generiert ..."
              );
            }
          );
        }
        if (!data.showIn) {
          data.showIn = "gallery";
        }

        this[`${type}Files`].push(data);
        this.$emit("save", false);
      });
    },
    setMainFiles(newVal) {
      const order = newVal.map(v => v.id);
      this.preventMainWatch = true;
      this.mainFiles = _.sortBy(this.mainFiles, file => {
        return _.indexOf(order, file.id);
      });
    },
    async removeFile(id, type) {
      const isConfirmed = await this.$confirm(
        "Wollen Sie die Datei und das eventuell dazugehörige Bild wirklich löschen?",
        confirmWarningConfig
      );
      if (!isConfirmed) {
        return;
      }
      const index = this[`${type}Files`].findIndex(f => f.id === id);
      if (
        !this.$refs.poiImagePreview?.isImageFromExternalSource(
          this[`${type}Files`][index]
        )
      ) {
        this.$emit("addToDestroyList", id);
      }

      if (type === "file") {
        const picture = this[`${type}Files`].find(f => f.id === id)?.picture;
        if (picture?.id) {
          this.$emit("addToDestroyList", picture.id);
        }
      }

      this[`${type}Files`].splice(index, 1);
    },
    featureChecked(checked, id) {
      if (!Array.isArray(this.editedRoom.features)) {
        this.$set(this.editedRoom, "features", []);
      }

      if (checked && !this.editedRoom.features.includes(id)) {
        this.editedRoom.features.push(id);
      } else if (!checked && this.editedRoom.features.includes(id)) {
        this.editedRoom.features.remove(id);
      }
      this.editedRoom.features = [...new Set(this.editedRoom.features)];
    }
  },
  computed: {
    mainFiles: {
      get() {
        return this.editedRoom?.pictures ?? [];
      },
      set(value) {
        this.editedRoom.pictures = value;
      }
    },
    conferenceRoomsFeatureGroups() {
      const groups = this.$store.state.featureGroups;
      return groups.filter(group =>
        group.services?.includes("conferenceRooms")
      );
    }
  }
};
